module.exports = __webpack_public_path__ + "static/img/Frame_03.47fbee3e.svg";